import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AppConfig } from 'src/app/config-service/app.config';
import { FaqServiceResModel } from '../models/faq-models';

@Injectable({
  providedIn: 'root'
})
export class FaqService {

  constructor(private http:HttpClient) { }

  getFaq= () => {
    return this.http.get<FaqServiceResModel>(AppConfig.settings.apiServer.url + "/api/faq",
      {
        params:{
          type: 'AFC',
          region: AppConfig.settings.city.region,
          lang: AppConfig.settings.apiServer.lang,
        }
      }
    ).pipe(
      map(response => response.faq)
    )
  }
}
